import { Route, Routes } from "react-router-dom";
import { InventoryPage } from "~/pages/inventory/inventory";
import { Space } from "~/lib/types";
import { AggregateScoreType } from "~/operations";
import { QueryPacksRoutes } from "./query-packs-routes";
import { SpaceOrWorkspaceScope, SpaceScope } from "~/hooks/useScope";
import { FirewatchPage } from "~/components/FirewatchPage";
import { Software } from "~/pages/space/software/Software/Software";
import { PageLayout } from "~/routes";
import { AssetRoutes } from "~/routes/space/asset-routes";

type Props = {
  scope: SpaceOrWorkspaceScope;
  spaceScope: SpaceScope;
  space: Space; // TODO: Deprecated prop
};

export function InventoryRoutes({ scope, spaceScope, space }: Props) {
  return (
    <Routes>
      <Route element={<PageLayout />}>
        <Route
          index
          element={<InventoryPage scope={scope} spaceScope={spaceScope} />}
        />
        <Route
          path="/query-packs/*"
          element={<QueryPacksRoutes {...{ space, scope }} />}
        />
        <Route
          path="exposed-assets"
          element={
            <FirewatchPage
              {...{
                space: spaceScope,
                scope,
                pageType: AggregateScoreType.Asset,
                docTitle: ["Exposed Assets", "Inventory"],
              }}
            />
          }
        />

        <Route path="software">
          <Route
            index
            element={
              <FirewatchPage
                {...{
                  space: spaceScope,
                  scope,
                  pageType: AggregateScoreType.Software,
                  docTitle: ["Software", "Inventory"],
                }}
              />
            }
          />
        </Route>
      </Route>
      <Route
        path="software/:softwareId"
        element={<Software {...{ space: spaceScope, scope }} />}
      />
      <Route path="/*" element={<AssetRoutes {...{ space, scope }} />} />
    </Routes>
  );
}
